import {
    UPDATE_QUIZ_DATA,
    UPDATE_ANSWER_DATA,
    UPDATE_ANSWER_SINGLE_DATA,
    CLEAR_ANSWER_DATA_BY_INDEX,
    CLEAR_ANSWER_DATA,
} from '../actions';

const initialState = {
    answerData: {},
};

export default function quizReducer(state = initialState, action) {
    switch (action.type) {
    case UPDATE_ANSWER_DATA: {
        const { data } = action;
        return Object.assign({}, state, {
            answerData: data,
        });
    }
    case UPDATE_ANSWER_SINGLE_DATA: {
        const { data } = action;
        return Object.assign({}, state, {
            answerData: Object.assign({}, state.answerData, {
                [data.index]: {
                    [data.value]: data.isCheck
                }
            }),
        });
    }
    case CLEAR_ANSWER_DATA_BY_INDEX: {
        const { data } = action;
        return Object.assign({}, state, {
            answerData: Object.assign({}, state.answerData, {
                [data.index]: {},
            })
        });
    }
    case CLEAR_ANSWER_DATA: {
        return Object.assign({}, state, {
            answerData: {},
        });
    }
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./reducers/Quiz.js